export default "__VITE_PUBLIC_ASSET__e36e348e__"